// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.lee-scratch {\n  position: relative;\n}\n.lee-scratch .canvas {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 2;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
